import css from "./popUp.module.css";
import React from "react";

const PopUpLibr = React.forwardRef(({ onClick }, ref) => {
  return (
    <div className={css.librPopWrap} ref={ref} onClick={onClick}>
      <p className={css.mainPopPLib}>
        Зареєструйтеся на сайті як бібліотекар — і отримайте знижку!
        <br /> Окрім знижки, пропонуємо бібліотекам:
        <br /> - розіграші подарунків;
        <br /> - презентації книжок;
        <br /> - підтримку подій і заходів;
        <br /> - швидке й зручне замовлення на сторінці "Прайс для гурту".
        <br />
        Замовлення для бібліотек доставляємо безплатно!
      </p>
    </div>
  );
});
export default PopUpLibr;
